import React,{useEffect, useState} from 'react'
import "../Styles/FirstCard.scss"
import emoji from "../assets/Vector.svg"
const FirstCard = ({result}) => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (result) {
      setLoading(false);
    }
  }, [result]);
  return (
    <div className=" firstWrapper">
      <div className="text">Marks</div>
      {
        loading ? <div className="text3">Loading...</div>:(<>
         <div className="text2">{result?.obtainedMarks}</div>
         <div className="text3">{result?.totalExamMarks}</div>
        </>)
      }
     
      <div className="score">
        <div style={{"font-weight":"700"}} >Topper score - {result?.bestObtainedMarks-result?.obtainedMarks}</div>
        <div className="imgdiv">
          <img
            loading="lazy"
            src={emoji}
            style={{width:"2.25rem","shrink":"0"}}
            
          />
          <div>
            <span style={{fontWeight:"600"}} >Great Job!</span> you are
            only 16 marks <br />
            behind the topper. Keep working hard
          </div>
        </div>
      </div>
    </div>
  )
}

export default FirstCard